import React, { useState, useEffect, useRef, useMemo } from "react";
import TiptapEditor from "../../../atoms/Tiptap/TiptapEditor.jsx";

const FeedbackTextEditor = ({ value, onChange, uploadFileV2, readOnly = false, placeholder, width = 'width-value-field', defaultValue, onBlur,  onKeyUp}) => {
    let quillRef = useRef();
    const [text, setText] = useState(value);

    const handleChange = (name, value) => {
        setText(value);
    }

    useEffect(() => {
        onChange(text)
    }, [text])

    const handleQuillImageUpload = () => {
        const input = document.createElement("input");
        input.setAttribute("type","file");
        input.setAttribute("accept", "image/*");
        input.click();
        input.onchange = async (e) => {
            const file = e?.target?.files?.[0] || e[0];
            const response = await uploadFileV2(file,{
                public: "True",
            });
            if(response)
            {   
                const uploadedFileURL = response?.data?.["url"] + response?.data?.fields["key"];
                let quill = quillRef?.current?.getEditor();
                const range = quill?.getSelection(true);
                quill?.insertEmbed(range.index, 'image', uploadedFileURL);
            }
        }
    };
            
    const modules = useMemo(() => ({ 
        toolbar: {
            container: [
                [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
                [{size: []}],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
                ['link', 'image', 'video']
            ],
            handlers: {
                image: handleQuillImageUpload,
            }  
        },
        clipboard: {
            // toggle to add extra line breaks when pasting HTML:
            matchVisual: false,
        }
    }),[]);

    return (
        <div className={width}>
            <TiptapEditor
                isDisabled={readOnly}
                placeholder={placeholder || ""}
                value={text}
                handleChange={handleChange}
                handleBlur={(e) => onBlur({...e, type: 'blur'})}
                handleKeyUp={onKeyUp}
                // ref={quillRef}
            />
        </div>
    );
}
export default FeedbackTextEditor;